module.exports = __webpack_public_path__ + "img/view.0c0b5242.svg";